import React from 'react';

/* ================================
   SERVICES GRID STYLES
================================ */
const servicesStyles = `
/* FORCE WHITE CANVAS */
html, body {
  background: #ffffff;
}

/* SECTION */
.services-section {
  width: 100%;
  min-height: auto;   /* FILL SCREEN TO HIDE BLACK PARENT */
  background: #ffffff;
  margin: 0;
  padding-top: 150px;
}

/* CONTAINER */
.services-containers {
  max-width: 1285px;
  margin: 0 auto;
  padding: 0 40px;
  background: #ffffff; /* EXTRA SAFETY */
}

/* GRID */
.services-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
}

/* CARD */
.service-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;

  /* SOFT PREMIUM SHADOW */
  box-shadow:
    0 4px 10px rgba(15, 23, 42, 0.05),
    0 12px 30px rgba(15, 23, 42, 0.08);

  border: 1px solid #f1f5f9;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-6px);
  box-shadow:
    0 10px 25px rgba(15, 23, 42, 0.08),
    0 30px 60px rgba(15, 23, 42, 0.12);
}

/* HEADER */
.service-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.service-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #fff7ed;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #fb923c;
  flex-shrink: 0;
}

.service-icon i {
  font-size: 24px;
}

/* TITLES */
.service-header h3 {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.service-header p {
  font-size: 18px;
  color: #686767;
  margin: 4px 0 0;
}

/* LIST */
.service-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.service-card li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  color: #000000;
  margin-bottom: 12px;
}

.service-card li i {
  color: #fb923c;
  font-size: 18px;
  flex-shrink: 0;
}
`;

export default function ServicesGrid() {
  return (
    <>
      {/* INTERNAL CSS */}
      <style>{servicesStyles}</style>

      {/* SERVICES SECTION */}
      <section className="services-section">
        <div className="services-containers">
          <div className="services-grid">

            {/* MAINTENANCE */}
            <div className="service-card">
              <div className="service-header">
                <div className="service-icon">
                  <i className="bi bi-tools"></i>
                </div>
                <div>
                  <h3>Maintenance</h3>
                  <p>Preventive and emergency support</p>
                </div>
              </div>

              <ul>
                <li><i className="bi bi-check-circle"></i> Annual Maintenance Contracts (AMC)</li>
                <li><i className="bi bi-check-circle"></i> Preventive maintenance & health checks</li>
                <li><i className="bi bi-check-circle"></i> On-call and emergency support</li>
                <li><i className="bi bi-check-circle"></i> Mission-readiness assurance</li>
              </ul>
            </div>

            {/* REPAIR */}
            <div className="service-card">
              <div className="service-header">
                <div className="service-icon">
                  <i className="bi bi-gear"></i>
                </div>
                <div>
                  <h3>Repair</h3>
                  <p>Module-level diagnostics & repair</p>
                </div>
              </div>

              <ul>
                <li><i className="bi bi-check-circle"></i> PCB & module-level repair</li>
                <li><i className="bi bi-check-circle"></i> Processor, control & power cards</li>
                <li><i className="bi bi-check-circle"></i> Advanced diagnostics & fault isolation</li>
                <li><i className="bi bi-check-circle"></i> Defence & industrial electronics</li>
              </ul>
            </div>

            {/* DESIGN */}
            <div className="service-card">
              <div className="service-header">
                <div className="service-icon">
                  <i className="bi bi-pencil-square"></i>
                </div>
                <div>
                  <h3>Design</h3>
                  <p>Custom electronics solutions</p>
                </div>
              </div>

              <ul>
                <li><i className="bi bi-check-circle"></i> Defence electronics development</li>
                <li><i className="bi bi-check-circle"></i> Rugged power supplies</li>
                <li><i className="bi bi-check-circle"></i> Custom interface solutions</li>
                <li><i className="bi bi-check-circle"></i> System performance optimization</li>
              </ul>
            </div>

            {/* DEVELOPMENT */}
            <div className="service-card">
              <div className="service-header">
                <div className="service-icon">
                  <i className="bi bi-cpu"></i>
                </div>
                <div>
                  <h3>Development</h3>
                  <p>Test fixtures & prototyping</p>
                </div>
              </div>

              <ul>
                <li><i className="bi bi-check-circle"></i> Custom JIGs & breakout boxes</li>
                <li><i className="bi bi-check-circle"></i> Test fixtures & validation tools</li>
                <li><i className="bi bi-check-circle"></i> Defence-specific design constraints</li>
                <li><i className="bi bi-check-circle"></i> Rapid prototyping support</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
